module.exports = __webpack_public_path__ + "static/media/NotasFiscais7.29974cdb.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/LancNotasFiscais/NotasFiscais7.png
// module id = 2137
// module chunks = 0